(function () {
  'use strict';

  var config = window.TPCartProtectionConfig || {};
  var PRODUCT_ID = String(config.productId || '8693147795652');
  var VARIANT_ID = String(config.variantId || '46561300578500');
  var PRODUCT_TITLE = String(config.productTitle || 'حماية المقاس والإرجاع');
  var isArabic = String(config.locale || document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var busy = false;
  var applyQueued = false;
  var orphanCleanupStarted = false;

  function shopRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function isProtectionItem(item) {
    return item && (
      String(item.product_id || '') === PRODUCT_ID ||
      String(item.variant_id || item.id || '') === VARIANT_ID
    );
  }

  function analyzeCart(cart) {
    var protectionItems = [];
    var merchandiseCount = 0;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (isProtectionItem(item)) {
        protectionItems.push(item);
      } else {
        merchandiseCount += Number(item.quantity || 0);
      }
    });

    return {
      active: protectionItems.length > 0,
      protectionItems: protectionItems,
      merchandiseCount: merchandiseCount
    };
  }

  function syncGlobalCount(count) {
    var value = Math.max(0, Number(count || 0));
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = String(value);
      element.setAttribute('data-cart-count-value', String(value));
    });
  }

  function setBusyState(value) {
    busy = value;
    document.querySelectorAll('[data-tp-protection-toggle]').forEach(function (input) {
      input.disabled = value;
    });
    document.querySelectorAll('[data-tp-cart-protection]').forEach(function (box) {
      box.toggleAttribute('data-pending', value);
      box.setAttribute('aria-busy', value ? 'true' : 'false');
    });
  }

  function copy() {
    if (isArabic) {
      return {
        title: 'حماية المقاس والإرجاع',
        price: '+10 ر.س',
        eyebrow: 'راحة إضافية مع طلبك',
        description: 'إذا لم يكن المقاس مناسبًا، لن نحتسب رسوم الاسترجاع المعتادة بقيمة 45 ر.س على الطلبات المؤهلة.',
        note: 'رسوم الحماية بقيمة 10 ر.س غير قابلة للاسترداد.',
        error: 'تعذر تحديث حماية المقاس. حاولي مرة أخرى.',
        updating: 'جارٍ تحديث الحماية…'
      };
    }

    return {
      title: 'Size & Return Protection',
      price: '+10 SAR',
      eyebrow: 'Extra peace of mind',
      description: 'If the fit is not right, the usual 45 SAR return fee is waived for eligible requests.',
      note: 'The 10 SAR protection fee is non-refundable.',
      error: 'We could not update size protection. Please try again.',
      updating: 'Updating protection…'
    };
  }

  function cardMarkup(active, context) {
    var t = copy();
    var id = 'tp-protection-' + context;
    return '' +
      '<div class="tp-cart-protection" data-tp-cart-protection data-active="' + (active ? 'true' : 'false') + '">' +
        '<label class="tp-cart-protection__label" for="' + id + '">' +
          '<input class="tp-cart-protection__checkbox" type="checkbox" id="' + id + '" data-tp-protection-toggle ' + (active ? 'checked' : '') + '>' +
          '<span class="tp-cart-protection__emblem" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none"><path d="M12 3.2 19 6v5.2c0 4.7-2.8 7.9-7 9.8-4.2-1.9-7-5.1-7-9.8V6l7-2.8Z"/><path d="m8.7 12.1 2.1 2.1 4.5-4.7"/></svg>' +
          '</span>' +
          '<span class="tp-cart-protection__content">' +
            '<span class="tp-cart-protection__eyebrow">' + t.eyebrow + '</span>' +
            '<span class="tp-cart-protection__heading">' +
              '<strong>' + t.title + '</strong>' +
              '<span class="tp-cart-protection__price">' + t.price + '</span>' +
            '</span>' +
            '<span class="tp-cart-protection__description">' + t.description + '</span>' +
            '<span class="tp-cart-protection__note">' + t.note + '</span>' +
          '</span>' +
        '</label>' +
        '<span class="tp-cart-protection__status" data-tp-protection-status aria-live="polite"></span>' +
      '</div>';
  }

  function protectionRows(root) {
    if (!root) return [];
    return Array.from(root.querySelectorAll('[data-tp-cart-product="' + PRODUCT_ID + '"]'));
  }

  function markProtectionLines() {
    document.querySelectorAll('[data-tp-cart-product="' + PRODUCT_ID + '"]').forEach(function (row) {
      row.classList.add('tp-cart-protection-line');
      row.setAttribute('aria-hidden', 'true');
    });

    document.querySelectorAll('.tp-cart__item').forEach(function (row) {
      var title = row.querySelector('.tp-cart__item-title');
      if (!title) return;
      var text = (title.textContent || '').trim();
      var href = title.getAttribute('href') || '';
      if (text === PRODUCT_TITLE || decodeURIComponentSafe(href).indexOf(PRODUCT_TITLE.replace(/\s+/g, '-')) !== -1) {
        row.classList.add('tp-cart-protection-line');
        row.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function decodeURIComponentSafe(value) {
    try { return decodeURIComponent(value); } catch (error) { return value; }
  }

  function setControlState(active) {
    config.active = !!active;
    document.querySelectorAll('[data-tp-cart-protection]').forEach(function (box) {
      box.setAttribute('data-active', active ? 'true' : 'false');
    });
    document.querySelectorAll('[data-tp-protection-toggle]').forEach(function (input) {
      input.checked = !!active;
    });
  }

  function statusMessage(message) {
    document.querySelectorAll('[data-tp-protection-status]').forEach(function (status) {
      status.textContent = message || '';
    });
  }

  function ensureMainCartControl() {
    var summary = document.querySelector('.tp-cart__summary-inner');
    if (!summary) return;

    var count = Number(config.merchandiseCount || 0);
    var existing = summary.querySelector('[data-tp-cart-protection]');

    if (count <= 0) {
      if (existing) existing.remove();
      return;
    }

    if (!existing) {
      var holder = document.createElement('div');
      holder.innerHTML = cardMarkup(!!config.active, 'main');
      var card = holder.firstElementChild;
      var anchor = summary.querySelector('.tp-cart__note') || summary.querySelector('.tp-cart__checkout-btn');
      if (anchor) summary.insertBefore(card, anchor);
      else summary.appendChild(card);
    }
  }

  function ensureDrawerControl() {
    document.querySelectorAll('[data-tp-quick-cart]').forEach(function (sidebar) {
      var action = sidebar.querySelector('.previewCartAction');
      if (!action) return;

      var serviceRows = protectionRows(sidebar);
      var merchandiseRows = Array.from(sidebar.querySelectorAll('[data-item-row]')).filter(function (row) {
        return !row.classList.contains('tp-cart-protection-line') &&
          String(row.dataset.tpCartProduct || '') !== PRODUCT_ID;
      });

      var active = serviceRows.length > 0 || !!config.active;
      if (serviceRows.length > 0) config.active = true;

      var existing = action.querySelector('[data-tp-cart-protection]');
      if (!merchandiseRows.length) {
        if (existing) existing.remove();
        if (serviceRows.length && !orphanCleanupStarted && !busy) {
          cleanupOrphanProtection();
        }
        return;
      }

      if (!existing) {
        var holder = document.createElement('div');
        holder.innerHTML = cardMarkup(active, 'drawer');
        var card = holder.firstElementChild;
        var anchor = action.querySelector('.global-checkbox') || action.querySelector('.previewCartGroup');
        if (anchor) action.insertBefore(card, anchor);
        else action.insertBefore(card, action.firstChild);
      } else {
        existing.setAttribute('data-active', active ? 'true' : 'false');
        var input = existing.querySelector('[data-tp-protection-toggle]');
        if (input) input.checked = active;
      }
    });
  }

  function applyUI() {
    applyQueued = false;
    markProtectionLines();
    ensureMainCartControl();
    ensureDrawerControl();
    syncGlobalCount(config.merchandiseCount);
  }

  function queueApply() {
    if (applyQueued) return;
    applyQueued = true;
    window.requestAnimationFrame(applyUI);
  }

  async function fetchCart() {
    var response = await fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    if (!response.ok) throw new Error('Unable to read cart.');
    return response.json();
  }

  async function addProtection() {
    var response = await fetch(shopRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{
          id: Number(VARIANT_ID),
          quantity: 1
        }]
      })
    });
    if (!response.ok) {
      var errorPayload = null;
      try { errorPayload = await response.json(); } catch (error) {}
      throw new Error(errorPayload && (errorPayload.description || errorPayload.message) || 'Unable to add protection.');
    }
  }

  async function updateLines(updates) {
    var response = await fetch(shopRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates: updates })
    });
    if (!response.ok) throw new Error('Unable to update protection.');
    return response.json();
  }

  async function removeProtectionItems(items) {
    if (!items || !items.length) return;
    var updates = {};
    items.forEach(function (item) {
      if (item && item.key) updates[item.key] = 0;
    });
    if (Object.keys(updates).length) await updateLines(updates);
  }

  async function normalizeProtection(cart, shouldBeActive) {
    var state = analyzeCart(cart);

    if (shouldBeActive) {
      if (state.merchandiseCount <= 0) return cart;

      if (!state.protectionItems.length) {
        await addProtection();
        return fetchCart();
      }

      var updates = {};
      state.protectionItems.forEach(function (item, index) {
        if (!item.key) return;
        if (index === 0) {
          if (Number(item.quantity || 0) !== 1) updates[item.key] = 1;
        } else {
          updates[item.key] = 0;
        }
      });
      if (Object.keys(updates).length) {
        await updateLines(updates);
        return fetchCart();
      }
      return cart;
    }

    if (state.protectionItems.length) {
      await removeProtectionItems(state.protectionItems);
      return fetchCart();
    }

    return cart;
  }

  async function refreshPresentation(cart) {
    var state = analyzeCart(cart);
    config.active = state.active;
    config.merchandiseCount = state.merchandiseCount;
    syncGlobalCount(state.merchandiseCount);
    setControlState(state.active);

    if (document.querySelector('.tp-cart__summary-inner')) {
      window.location.reload();
      return;
    }

    if (window.TPQuickCart && typeof window.TPQuickCart.refresh === 'function') {
      await window.TPQuickCart.refresh();
      return;
    }

    queueApply();
  }

  async function toggleProtection(input) {
    if (busy) return;

    var desired = !!input.checked;
    var previous = !desired;
    var t = copy();

    setBusyState(true);
    statusMessage(t.updating);

    try {
      var cart = await fetchCart();
      var state = analyzeCart(cart);

      if (desired && state.merchandiseCount <= 0) {
        input.checked = false;
        setControlState(false);
        return;
      }

      cart = await normalizeProtection(cart, desired);
      statusMessage('');
      await refreshPresentation(cart);
    } catch (error) {
      console.error('[Toni Pons Cart Protection]', error);
      setControlState(previous);
      statusMessage(t.error);
    } finally {
      setBusyState(false);
    }
  }

  async function cleanupOrphanProtection() {
    if (orphanCleanupStarted || busy) return;
    orphanCleanupStarted = true;

    try {
      var cart = await fetchCart();
      var state = analyzeCart(cart);
      if (state.active && state.merchandiseCount <= 0) {
        await removeProtectionItems(state.protectionItems);
        config.active = false;
        config.merchandiseCount = 0;
        syncGlobalCount(0);

        if (document.querySelector('.tp-cart')) {
          window.location.reload();
        } else if (window.TPQuickCart && typeof window.TPQuickCart.refresh === 'function') {
          await window.TPQuickCart.refresh();
        }
      }
    } catch (error) {
      console.error('[Toni Pons Cart Protection cleanup]', error);
    } finally {
      orphanCleanupStarted = false;
    }
  }

  function hydrateFromCart(cart) {
    if (!cart) return;
    var state = analyzeCart(cart);
    config.active = state.active;
    config.merchandiseCount = state.merchandiseCount;
    syncGlobalCount(state.merchandiseCount);
    setControlState(state.active);

    if (state.active && state.merchandiseCount <= 0) cleanupOrphanProtection();
    queueApply();
  }

  function observeDrawer() {
    document.querySelectorAll('[data-tp-quick-cart]').forEach(function (sidebar) {
      if (sidebar.dataset.tpProtectionObserved === 'true') return;
      sidebar.dataset.tpProtectionObserved = 'true';

      var observer = new MutationObserver(function (mutations) {
        var hasExternalMutation = mutations.some(function (mutation) {
          return Array.from(mutation.addedNodes || []).some(function (node) {
            return !(node.nodeType === 1 && node.matches && node.matches('[data-tp-cart-protection]'));
          }) || Array.from(mutation.removedNodes || []).some(function (node) {
            return !(node.nodeType === 1 && node.matches && node.matches('[data-tp-cart-protection]'));
          });
        });

        if (hasExternalMutation) queueApply();
      });

      observer.observe(sidebar, { childList: true, subtree: true });
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target && event.target.closest ? event.target.closest('[data-tp-protection-toggle]') : null;
    if (!input) return;
    toggleProtection(input);
  });

  document.addEventListener('click', function (event) {
    if (!busy) return;
    if (event.target.closest('.button-checkout, .tp-cart__checkout-btn')) {
      event.preventDefault();
      event.stopPropagation();
      statusMessage(copy().updating);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    if (busy && event.target && event.target.matches('#tp-cart-form')) {
      event.preventDefault();
      statusMessage(copy().updating);
    }
  }, true);

  document.addEventListener('tp:cart:opened', function (event) {
    hydrateFromCart(event.detail && event.detail.cart);
  });

  function init() {
    markProtectionLines();
    syncGlobalCount(config.merchandiseCount);
    ensureMainCartControl();
    ensureDrawerControl();
    observeDrawer();

    if (config.active && Number(config.merchandiseCount || 0) <= 0) {
      cleanupOrphanProtection();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    queueApply();
  });
})();
